import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StaffTable from "../components/StaffTable";
import { API_URL, LOCATION_ID, TOKEN } from "..";
import { Spinner } from "react-bootstrap";

const StaffPage = () => {
    const [data, setData] = useState({ admins: [], users: [] });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeTab, setActiveTab] = useState("admins");

    const fetchUsers = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(
                `https://services.leadconnectorhq.com/users/?locationId=${LOCATION_ID}`,
                {
                    method: "GET",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${TOKEN}`,
                        Version: "2021-07-28"
                    },
                }
            );
            const dataFor = await response.json();
            setLoading(false);
            if (response.status === 200 && dataFor.users) {
                // Separate admins and users based on role
                const admins = dataFor.users
                    .filter(user => user?.roles?.role?.toLowerCase() === "admin")
                    .map(user => ({
                        id: user.id || 'N/A',
                        name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || 'N/A',
                        phone: user.phone || 'N/A',
                        role: user?.roles ? user.roles.role : 'N/A'
                    }));
                const users = dataFor.users
                    .filter(user => user?.roles?.role?.toLowerCase() !== "admin")
                    .map(user => ({
                        id: user.id || 'N/A',
                        name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.name || 'N/A',
                        phone: user.phone || 'N/A',
                        role: user?.roles ? user.roles.role : 'N/A'
                    }));

                setData({ admins, users });
            } else {
                throw new Error(dataFor.message || 'Failed to fetch users');
            }
        } catch (err) {
            setLoading(false);
            setError(err.message || 'Error fetching users from GoHighLevel');
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <MasterLayout>
            <Breadcrumb title="Staff" />

            {error && (
                <div className="alert alert-danger alert-dismissible fade show mb-4" role="alert">
                    {error}
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setError(null)}
                        aria-label="Close"
                    ></button>
                </div>
            )}

            <ul className="nav nav-tabs mb-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === "admins" ? "active" : ""}`}
                        onClick={() => setActiveTab("admins")}
                    >
                        Admins ({data.admins.length})
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === "users" ? "active" : ""}`}
                        onClick={() => setActiveTab("users")}
                    >
                        Users ({data.users.length})
                    </button>
                </li>
            </ul>

            {loading && (
                <div className="text-center mt-4">
                    <Spinner />
                    <p>Loading staff data...</p>
                </div>
            )}

            {!loading && activeTab === "admins" && data.admins.length === 0 && (
                <p>No Admins Found...</p>
            )}
            {!loading && activeTab === "users" && data.users.length === 0 && (
                <p>No Users Found...</p>
            )}

            {!loading && activeTab === "admins" && data.admins.length > 0 && (
                <StaffTable data={data.admins} showPrivileges={false} />
            )}
            {!loading && activeTab === "users" && data.users.length > 0 && (
                <StaffTable data={data.users} showPrivileges={true} />
            )}
        </MasterLayout>
    );
};

export default StaffPage;